import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  x: "0px",
  y: "0px",
  width: "48px",
  height: "48px",
  viewBox: "0 0 48 48",
  style: {"enable-background":"new 0 0 48 48"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      class: "st0",
      cx: "23.5",
      cy: "44.7",
      rx: "10.4",
      ry: "3.3"
    }, null, -1),
    _createElementVNode("path", {
      class: "st1",
      fill: "#D36868",
      d: "M23.5,0c-9.4,0-17,7.5-17,16.8s17,28,17,28s17-18.7,17-28S32.9,0,23.5,0z"
    }, null, -1),
    _createElementVNode("circle", {
      class: "st2",
      fill: "#AF5151",
      cx: "23.5",
      cy: "15.5",
      r: "4.2"
    }, null, -1),
    _createElementVNode("path", {
      class: "st3",
      fill: "#913D3D",
      d: "M23.5,12.2c2.2,0,3.9,1.6,4.2,3.8c0-0.2,0.1-0.3,0.1-0.5c0-2.3-1.9-4.2-4.2-4.2s-4.2,1.9-4.2,4.2\n\tc0,0.2,0,0.3,0.1,0.5C19.6,13.9,21.3,12.2,23.5,12.2z"
    }, null, -1)
  ]))]))
}
export default { render: render }